import Button, { ButtonGroup } from '@atlaskit/button';
import styled from '@emotion/styled';
import React, { FunctionComponent } from 'react';
import { ActionsContainer, Container, Description, Header } from './atlaskit';
import WhoopsError from '../../images/WhoopsError';

const StyledContainer = styled(Container)`
    display: flex;
    flex-direction: column;
`;

const StyledLogoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
`;

const Logo = styled(WhoopsError)`
    width: 60px;
    height: 60px;
`;

const UnhandledErrors: FunctionComponent = () => (
    <StyledContainer>
        <StyledLogoContainer>
            <Logo />
        </StyledLogoContainer>
        <Header>Something went wrong</Header>
        <Description>
            But don’t worry. Refresh the page to continue using Swanly. If the problem persists contact our support.
        </Description>
        <ActionsContainer>
            <ButtonGroup>
                <Button appearance="link" href="https://apps.appf.re/sw/support/p2" target="_new">
                    Contact support
                </Button>
            </ButtonGroup>
        </ActionsContainer>
    </StyledContainer>
);

export default UnhandledErrors;
